module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9sdTr"))).then(() => parcelRequire('d0iPb'));